// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1d69h","title":"Images90_title__3rA5l","images":"Images90_images__KQ4zr"};